import { createFileRoute } from "@tanstack/react-router";

import { OrderForm } from "@/features/dashboard/pedidos/_components";

export const Route = createFileRoute("/_private/dashboard/_base/pedidos/cadastrar/")({
  component: OrderForm
});
